import { render, staticRenderFns } from "./Lgx266188571453423616.vue?vue&type=template&id=a1254e42&"
import script from "./Lgx266188571453423616.vue?vue&type=script&lang=js&"
export * from "./Lgx266188571453423616.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports